import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { reducerPaths } from "../../app/reducerPaths";
import { baseQueryWithAuth } from "../methods/baseQueryWithAuth";

export const carfaxApi = createApi({
  reducerPath: reducerPaths.carfaxApi, // Unique key in Redux store
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    completeCarfaxPayment: builder.mutation({
      query: ({ payload }) => ({
        url: `/carfax/payment/save`,
        method: "POST",
        body: payload
      }),
    }),
    getCarfaxReport: builder.query({
      query: ({ Vehicle_Id, vin, state }) => ({
        url: `/carfaxevalvationreport/${Vehicle_Id}/${vin}/${state ? state : "4"}`,
        method: "GET"
      })
    })
  }),
});

export const {
  useCompleteCarfaxPaymentMutation,
  useLazyGetCarfaxReportQuery,
} = carfaxApi;